import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * The function `cn` is a TypeScript function that merges multiple class lists into a single class
 * list.
 * @param {ClassValue[]} classLists - classLists is a rest parameter that allows you to pass in
 * multiple class lists as arguments. Each class list is represented by the ClassValue type.
 *
 * For the function to work correctly, you must add all custom values that do not exist in the default Tailwind configuration.
 */
export const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: ['display-sm-28', 'display-md-34', 'display-lg-46', 'display-xl-58'],
        },
      ],
    },
  },
});

export const cn = (...classLists: ClassValue[]) => twMerge(clsx(classLists));
